import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const Caption = Loadable({
    loader: () => import(/* webpackChunkName: "Caption" */ './caption'),
    loading: () => <div />,
});
export const NormalCaption = Loadable({
    loader: () => import(/* webpackChunkName: "NormalCaption" */ './normalCaption'),
    loading: () => <div />,
});
